import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;

    window.scrollTo(0, 0);

    const correctIfMoved = () => {
      if (window.scrollY !== 0 || window.scrollX !== 0) {
        window.scrollTo(0, 0);
      }
    };

    window.addEventListener("scroll", correctIfMoved, { passive: true });

    const stopListening = window.setTimeout(() => {
      window.removeEventListener("scroll", correctIfMoved);
    }, 1000);

    return () => {
      window.removeEventListener("scroll", correctIfMoved);
      window.clearTimeout(stopListening);
    };
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
